"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useKlarnaData = exports.CONFIG_UPDATED_EVENT = void 0;
var _react = require("react");
var _base = require("@site/pattern-library-utils/base.functions");
var _utils = require("./utils");
const CONFIG_UPDATED_EVENT = exports.CONFIG_UPDATED_EVENT = 'merchandising_config_data_updated_event';
const getMarket = () => {
  return (0, _base.getCookieValue)('market') || 'en-US';
};
const getCountry = () => {
  return getMarket()?.split('-')?.[1] || 'US';
};
const getCurrency = () => {
  return (0, _base.getCookieValue)('currency') || 'USD';
};
const getConfigData = async paymentConfigUrl => {
  const market = getMarket();
  const country = getCountry();
  const currency = getCurrency();
  const res = await fetch(paymentConfigUrl);
  try {
    const {
      installmentOptions
    } = await res.json();
    const klarnaOption = installmentOptions.find(option => option?.installmentType?.toLowerCase() === 'klarna');
    const currentCurrencyInstallmentData = klarnaOption.installmentData.digital[currency];
    const currentMarketAndCountryCurrencyData = currentCurrencyInstallmentData.find(currencyData => {
      return currencyData?.supportedCountries?.[country]?.supportedLocales?.includes(market);
    });
    const configData = currentMarketAndCountryCurrencyData.additionalConfiguration;
    return configData;
  } catch (e) {
    throw new Error('No config for Klarna was found');
  }
};
const getKlarnaData = async ({
  channel,
  dataClientId,
  osmUrl,
  placementKey,
  purchaseAmount
}) => {
  const market = getMarket();
  const url = `${osmUrl}?client_id=${dataClientId}&placement_key=${placementKey}&` + `locale=${market}&channel=${channel}&purchase_amount=${purchaseAmount}`;
  const res = await fetch(url);
  const data = await res?.json();
  if (!res?.ok) {
    throw Error(JSON.stringify(data));
  }
  return (0, _utils.handleKlarnaResponse)(data, dataClientId);
};
const useKlarnaData = ({
  channel,
  paymentConfigUrl,
  placementKey,
  purchaseAmount
}) => {
  const [configData, setConfigData] = (0, _react.useState)(null);
  const [data, setData] = (0, _react.useState)(null);
  const [error, setError] = (0, _react.useState)(null);
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!configData) {
      const fetchConfig = async () => {
        try {
          const config = await getConfigData(paymentConfigUrl);
          setConfigData(config);
        } catch (e) {
          setError(e);
        }
      };
      fetchConfig();
    }
  }, [paymentConfigUrl, configData]);
  (0, _react.useEffect)(() => {
    if (!data && configData && !isLoading) {
      const getData = async config => {
        const {
          osmUrl,
          dataClientId
        } = config;
        if (config && !data && !isLoading && !error) {
          setIsLoading(true);
          try {
            const klarnaData = await getKlarnaData({
              purchaseAmount,
              channel,
              placementKey,
              osmUrl,
              dataClientId
            });
            setData(klarnaData);
          } catch (e) {
            setError(e);
          } finally {
            setIsLoading(false);
          }
        }
      };
      getData(configData);
    }
  }, [configData, isLoading, error, data, channel, placementKey, purchaseAmount]);
  return {
    data,
    error,
    isLoading
  };
};
exports.useKlarnaData = useKlarnaData;